<template>
	<div
		class="module module-social-share-footer"
		:class="{vertical: this.$props.vertical}"
		data-e2e="social-sharebar"
	>

		<div
			class="socialshare-container"
			:data-metrics-module="metrics.module"
		>
			<div class="share-footer-container" @click="toggleTooltip()">
				<div class="share-text">{{ translation('Share') }}</div>
				<div class="icon-sb-footer-svg icon-sb-footer-share">
					<svg class="icon-sb-footer-svg" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path class="icon-sb-footer-svg" d="M15 20C14.1667 20 13.4583 19.7083 12.875 19.125C12.2917 18.5417 12 17.8333 12 17C12 16.8833 12.0083 16.7623 12.025 16.637C12.0417 16.5123 12.0667 16.4 12.1 16.3L5.05 12.2C4.76667 12.45 4.45 12.6457 4.1 12.787C3.75 12.929 3.38333 13 3 13C2.16667 13 1.45833 12.7083 0.875 12.125C0.291667 11.5417 0 10.8333 0 10C0 9.16667 0.291667 8.45833 0.875 7.875C1.45833 7.29167 2.16667 7 3 7C3.38333 7 3.75 7.07067 4.1 7.212C4.45 7.354 4.76667 7.55 5.05 7.8L12.1 3.7C12.0667 3.6 12.0417 3.48767 12.025 3.363C12.0083 3.23767 12 3.11667 12 3C12 2.16667 12.2917 1.45833 12.875 0.875C13.4583 0.291667 14.1667 0 15 0C15.8333 0 16.5417 0.291667 17.125 0.875C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6167 6 14.25 5.929 13.9 5.787C13.55 5.64567 13.2333 5.45 12.95 5.2L5.9 9.3C5.93333 9.4 5.95833 9.51233 5.975 9.637C5.99167 9.76233 6 9.88333 6 10C6 10.1167 5.99167 10.2373 5.975 10.362C5.95833 10.4873 5.93333 10.6 5.9 10.7L12.95 14.8C13.2333 14.55 13.55 14.354 13.9 14.212C14.25 14.0707 14.6167 14 15 14C15.8333 14 16.5417 14.2917 17.125 14.875C17.7083 15.4583 18 16.1667 18 17C18 17.8333 17.7083 18.5417 17.125 19.125C16.5417 19.7083 15.8333 20 15 20ZM15 4C15.2833 4 15.5207 3.90433 15.712 3.713C15.904 3.521 16 3.28333 16 3C16 2.71667 15.904 2.479 15.712 2.287C15.5207 2.09567 15.2833 2 15 2C14.7167 2 14.4793 2.09567 14.288 2.287C14.096 2.479 14 2.71667 14 3C14 3.28333 14.096 3.521 14.288 3.713C14.4793 3.90433 14.7167 4 15 4ZM3 11C3.28333 11 3.521 10.904 3.713 10.712C3.90433 10.5207 4 10.2833 4 10C4 9.71667 3.90433 9.479 3.713 9.287C3.521 9.09567 3.28333 9 3 9C2.71667 9 2.479 9.09567 2.287 9.287C2.09567 9.479 2 9.71667 2 10C2 10.2833 2.09567 10.5207 2.287 10.712C2.479 10.904 2.71667 11 3 11ZM15 18C15.2833 18 15.5207 17.904 15.712 17.712C15.904 17.5207 16 17.2833 16 17C16 16.7167 15.904 16.4793 15.712 16.288C15.5207 16.096 15.2833 16 15 16C14.7167 16 14.4793 16.096 14.288 16.288C14.096 16.4793 14 16.7167 14 17C14 17.2833 14.096 17.5207 14.288 17.712C14.4793 17.904 14.7167 18 15 18Z"/>
					</svg>
				</div>
			</div>
			<div class="share-icons" v-if="showTooltip">
				<div class="share-icons-tooltip">
					<template v-for="(item, index) in items">
						<a
							:class="[item.className, {right: item.position === 'right'}]"
							v-metric="{
							module: metrics.module,
							link: item.metric
						}"
							:data-metrics-type="metrics.type"
							:data-sharetype="item.type"
							:href="item.href"
							:title="item.title"
							rel="noopener"
							:key="chronicleId+index"
							role="link"
							tabindex="0"
							@click="setClickHandler(item.type)"
							v-if="item.type === 'email'"
						>
							<div
								:class="item.icon"
							>
								<svg width="20" height="16" viewBox="0 0 20 16" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45 0.196 0.979333 0.588 0.588C0.979333 0.196 1.45 0 2 0H18C18.55 0 19.021 0.196 19.413 0.588C19.8043 0.979333 20 1.45 20 2V14C20 14.55 19.8043 15.021 19.413 15.413C19.021 15.8043 18.55 16 18 16H2ZM10 8.825C10.0833 8.825 10.1707 8.81233 10.262 8.787C10.354 8.76233 10.4417 8.725 10.525 8.675L17.6 4.25C17.7333 4.16667 17.8333 4.06267 17.9 3.938C17.9667 3.81267 18 3.675 18 3.525C18 3.19167 17.8583 2.94167 17.575 2.775C17.2917 2.60833 17 2.61667 16.7 2.8L10 7L3.3 2.8C3 2.61667 2.70833 2.61233 2.425 2.787C2.14167 2.96233 2 3.20833 2 3.525C2 3.69167 2.03333 3.83733 2.1 3.962C2.16667 4.08733 2.26667 4.18333 2.4 4.25L9.475 8.675C9.55833 8.725 9.646 8.76233 9.738 8.787C9.82933 8.81233 9.91667 8.825 10 8.825Z"
										fill="#3557FF" />
								</svg>
							</div>
							<span
								class="visually-hidden"
							>
							{{ item.msg }}
						</span>
						</a>

						<a
							:class="[item.className, {right: item.position === 'right'}]"
							v-metric="{
							module: metrics.module,
							link: item.metric
						}"
							:data-metrics-type="metrics.type"
							:data-sharetype="item.type"
							:href="item.href"
							:title="item.title"
							rel="noopener"
							:key="chronicleId+index"
							role="link"
							tabindex="0"
							@click.prevent="setClickHandler(item.type)"
							v-else
						>
							<div
								:class="item.icon"
							>
								<svg v-if="item.type === 'facebook'" width="20" height="20" viewBox="0 0 20 20"
									fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M20 10.0611C20 4.50451 15.5229 0 10 0C4.47715 0 0 4.50451 0 10.0611C0 15.0828 3.65684 19.2452 8.4375 20V12.9694H5.89844V10.0611H8.4375V7.84452C8.4375 5.32296 9.93047 3.93012 12.2146 3.93012C13.3088 3.93012 14.4531 4.12663 14.4531 4.12663V6.60261H13.1922C11.95 6.60261 11.5625 7.37822 11.5625 8.17387V10.0611H14.3359L13.8926 12.9694H11.5625V20C16.3432 19.2452 20 15.083 20 10.0611Z"
										fill="#3557FF" />
								</svg>

								<svg v-else-if="item.type === 'twitter'" width="20" height="20" viewBox="0 0 20 20"
									fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="20" height="20" rx="10" fill="#3557FF" class="tw-icon-bg"/>
									<g clip-path="url(#clip0_15789_109)">
										<path
											d="M10.9562 9.07857L15.3074 4H14.2763L10.4981 8.40965L7.48053 4H4.00006L8.5633 10.6682L4.00006 15.9938H5.03122L9.02108 11.3371L12.2079 15.9938H15.6884L10.9559 9.07857H10.9562ZM9.54388 10.7269L9.08153 10.0629L5.40277 4.77941H6.98657L9.95537 9.04337L10.4177 9.70737L14.2768 15.2499H12.693L9.54388 10.7272V10.7269Z"
											fill="white" />
									</g>
									<defs>
										<clipPath id="clip0_15789_109">
											<rect width="11.6883" height="12" fill="white"
												transform="translate(4.00006 4)" />
										</clipPath>
									</defs>
								</svg>

								<svg v-else-if="item.type === 'copy'" width="20" height="13" viewBox="0 0 20 13" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M15 10H12.975C12.6917 10 12.4583 9.90417 12.275 9.7125C12.0917 9.52083 12 9.28333 12 9C12 8.71667 12.0958 8.47917 12.2875 8.2875C12.4792 8.09583 12.7167 8 13 8H15V6C15 5.71667 15.0958 5.47917 15.2875 5.2875C15.4792 5.09583 15.7167 5 16 5C16.2833 5 16.5208 5.09583 16.7125 5.2875C16.9042 5.47917 17 5.71667 17 6V8H19C19.2833 8 19.5208 8.09583 19.7125 8.2875C19.9042 8.47917 20 8.71667 20 9C20 9.28333 19.9042 9.52083 19.7125 9.7125C19.5208 9.90417 19.2833 10 19 10H17V12C17 12.2833 16.9042 12.5208 16.7125 12.7125C16.5208 12.9042 16.2833 13 16 13C15.7167 13 15.4792 12.9042 15.2875 12.7125C15.0958 12.5208 15 12.2833 15 12V10ZM8 10H5C3.61667 10 2.4375 9.5125 1.4625 8.5375C0.4875 7.5625 0 6.38333 0 5C0 3.61667 0.4875 2.4375 1.4625 1.4625C2.4375 0.4875 3.61667 0 5 0H8C8.28333 0 8.52083 0.0958333 8.7125 0.2875C8.90417 0.479167 9 0.716667 9 1C9 1.28333 8.90417 1.52083 8.7125 1.7125C8.52083 1.90417 8.28333 2 8 2H5C4.16667 2 3.45833 2.29167 2.875 2.875C2.29167 3.45833 2 4.16667 2 5C2 5.83333 2.29167 6.54167 2.875 7.125C3.45833 7.70833 4.16667 8 5 8H8C8.28333 8 8.52083 8.09583 8.7125 8.2875C8.90417 8.47917 9 8.71667 9 9C9 9.28333 8.90417 9.52083 8.7125 9.7125C8.52083 9.90417 8.28333 10 8 10ZM7 6C6.71667 6 6.47917 5.90417 6.2875 5.7125C6.09583 5.52083 6 5.28333 6 5C6 4.71667 6.09583 4.47917 6.2875 4.2875C6.47917 4.09583 6.71667 4 7 4H13C13.2833 4 13.5208 4.09583 13.7125 4.2875C13.9042 4.47917 14 4.71667 14 5C14 5.28333 13.9042 5.52083 13.7125 5.7125C13.5208 5.90417 13.2833 6 13 6H7ZM20 5H18C18 4.16667 17.7083 3.45833 17.125 2.875C16.5417 2.29167 15.8333 2 15 2H11.975C11.6917 2 11.4583 1.90417 11.275 1.7125C11.0917 1.52083 11 1.28333 11 1C11 0.716667 11.0958 0.479167 11.2875 0.2875C11.4792 0.0958333 11.7167 0 12 0H15C16.3833 0 17.5625 0.4875 18.5375 1.4625C19.5125 2.4375 20 3.61667 20 5Z"
										fill="#3557FF" />
								</svg>

								<svg v-else-if="item.type === 'whatsapp'" width="20" height="20" viewBox="0 0 20 20" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M10 6.10352e-05C4.48614 6.10352e-05 6.45317e-05 4.48613 6.45317e-05 10C6.45317e-05 11.7218 0.444846 13.4148 1.28832 14.9087L0.0161514 19.4478C-0.0255876 19.597 0.0148471 19.757 0.122673 19.8678C0.205716 19.9535 0.318759 20 0.434846 20C0.469628 20 0.504845 19.9956 0.539193 19.9874L5.27657 18.8139C6.72309 19.5904 8.35221 20 10 20C15.5139 20 20 15.5139 20 10C20 4.48613 15.5139 6.10352e-05 10 6.10352e-05ZM15.0305 13.5287C14.8165 14.1209 13.7905 14.6613 13.2974 14.7339C12.8548 14.7987 12.2948 14.8265 11.68 14.6335C11.3074 14.5161 10.8292 14.3604 10.2166 14.0991C7.64134 13.0009 5.95961 10.4405 5.83092 10.2713C5.70265 10.1022 4.78266 8.89699 4.78266 7.6496C4.78266 6.40221 5.4457 5.78874 5.68135 5.53482C5.917 5.28091 6.19483 5.21743 6.36613 5.21743C6.53743 5.21743 6.7083 5.21961 6.8583 5.22657C7.01613 5.23439 7.22787 5.167 7.43613 5.66178C7.65004 6.16961 8.16352 7.41699 8.22699 7.54438C8.29134 7.67134 8.33395 7.8196 8.24873 7.98873C8.16352 8.15786 8.12091 8.26351 7.99221 8.41177C7.86352 8.56003 7.72265 8.74221 7.607 8.85612C7.4783 8.98264 7.34482 9.1196 7.49439 9.37351C7.64395 9.62742 8.15917 10.4574 8.92264 11.1296C9.90308 11.9931 10.7305 12.2609 10.987 12.3878C11.2435 12.5148 11.3935 12.4935 11.5431 12.3244C11.6926 12.1548 12.1848 11.5839 12.3557 11.3305C12.5265 11.077 12.6978 11.1187 12.9335 11.2035C13.1692 11.2878 14.4313 11.9009 14.6878 12.0278C14.9444 12.1548 15.1157 12.2183 15.18 12.3239C15.2444 12.4291 15.2444 12.937 15.0305 13.5287Z"
										fill="#3557FF" />
								</svg>
							</div>
							<span
								class="visually-hidden"
							>
							{{ item.msg }}
						</span>
						</a>
					</template>

				</div>
			</div>
			<span v-if="showTooltipText" class="copy-link-tooltip">{{ translation('copied') }}</span>
		</div>
	</div>
</template>

<script>
import { ua } from 'webmd-useragent/index.es6';
/* eslint max-len: ["error", { "code": 1000, "tabWidth": 4 }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ['a'] }] */
import { clone } from 'lodash';
export default {
	name: 'GlobalSharebarFooter',
	props: {
		shareOrder: {
			type: Array,
			default() {
				return ['facebook', 'twitter', 'whatsapp', 'email', 'copy'];
			},
		},
		vertical: {
			type: Boolean,
			default: false,
		},
		facebook: {
			type: Object,
			default() {
				return {};
			},
		},
		twitter: {
			type: Object,
			default() {
				return {};
			},
		},
		whatsapp: {
			type: Object,
			default() {
				return {};
			},
		},
		copy: {
			type: Object,
			default() {
				return {};
			},
		},
		email: {
			type: Object,
			default() {
				return {};
			},
		},
		shareLink: {
			type: String,
			default: null,
		},
		shareTitle: {
			type: String,
			default: null,
		},
		shareWithTwoUrls: {
			type: Boolean,
			default: false,
		},
		customFbUrl: {
			type: String,
			required: false,
		},
		shareImage: {
			type: String,
			required: false,
		},
		lang: {
			type: String,
			required: false,
			default: null
		}
	},

	data() {
		return {
			chronicleId: '091e9c5e8136fcb5',
			metrics: {
				module: 'fm-shr',
				type: 'ad-hoc',
			},
			items: [],
			settings: {},
			shortenedUrls: {},
			showTooltip: false,
			showTooltipText: false,
			deviceInfo: false,
			isClickListenerAdded: false,
		};
	},

	computed: {
		getItems() {
			const self = this;
			const items = [];
			let { shareOrder } = this.$props;

			if (typeof shareOrder === 'undefined' || shareOrder.length <= 0) {
				shareOrder = ['facebook', 'twitter', 'whatsapp', 'email', 'copy'];
			}

			shareOrder.forEach((v) => {
				const obj = {
					className: `plugin-socialshare-link plugin-socialshare-${v}`,
					title: self.getShareTitle(v),
					msg: self.getShareTitle(v),
					metric: self.getMetricsText(v),
					position: '',
					type: v,
					icon: `icon-sb-footer-${v}`,
				};

				if (typeof self.$props[v] !== 'undefined') {
					// eslint-disable-next-line
					if(typeof self.$props[v].href !== 'undefined') {
						obj.href = self.$props[v].href;
					}

					if (typeof self.$props[v].position !== 'undefined') {
						obj.position = self.$props[v].position.toLowerCase();
					}

					self.settings[v] = self.$props[v];
				} else {
					self.settings[v] = {};
				}

				items.push(obj);
			});
			return items;
		},
	},

	created() {
		this.items = this.getItems;
	},

	methods: {
		getShareTitle(type = '') {
			let s = '';

			switch (type) {
				case 'facebook':
					s = this.translation('Share on Facebook');;
					break;
				case 'twitter':
					s = this.translation('Share on Twitter');
					break;
				case 'whatsapp':
          			s = this.translation('Share on WhatsApp');
          			break;
				case 'email':
					s = this.translation('Share via Email');
					break;
				case 'copy':
					s = this.translation('Copy');
					break;
				default:
					s = '';
			}

			return s;
		},
		getMetricsText(type = '') {
			let s = '';

			switch (type) {
				case 'facebook':
					s = 'fb';
					break;
				case 'twitter':
					s = 'tw';
					break;
				case 'whatsapp':
					s = 'whapp';
					break;
				case 'email':
					s = 'email';
					break;
				case 'copy':
					s = 'copy';
					break;
				default:
					s = '';
			}

			return s;
		},
		setClickHandler(type = '') {
			const windowOpts = 'height=400, width=580, scrollbars = 1, toolbar = 0, resizable = 1, status = 0, left = 25, top = 25';
			switch (type) {
				case 'facebook':
					window.open(this.getFacebookShareLink(this.settings[type].settings || {}), '', windowOpts);
					break;
				case 'twitter':
				setTimeout(() => {
						window.open(this.getTwitterShareLink(this.settings[type].settings || {}), '', windowOpts);
					}, 0);
					break;
				case 'whatsapp':
				setTimeout(() => {
						window.open(this.getWhatsappShareLink(this.settings[type].settings || {}), '', windowOpts);
					}, 0);
					break;
				case 'email':
					this.openEmail();
					break;
				case 'copy':
					this.copyLink();
					break;
				default:
			}
		},
		getFacebookShareLink(settings) {
			if (this.customFbUrl) {
				return this.customFbUrl;
			}

			const baseUrl = 'https://www.facebook.com/dialog/feed?app_id=385978254785998&display=popup';
			const picture = `&picture=${encodeURIComponent(settings.shareImg || '')}`;
			const redirect = `&redirect_uri=${encodeURIComponent('https://www.webmd.com/facebook-app-close')}`;
			const name = `&name=${encodeURIComponent(settings.shareTitle || '')}`;
			const link = `&link=${encodeURIComponent(settings.shareLink || '')}`;
			const caption = `&caption=${encodeURIComponent(settings.shareTitle || '')}`;
			const description = `&description=${encodeURIComponent(settings.shareDesc || '')}`;
			this.closeTooltip();
			return baseUrl + picture + redirect + name + link + caption + description;
		},
		getTwitterShareLink(settings) {
			const shortenedUrl = this.getShortenedUrl(settings.shareLink);
			let msg = '';
			if (this.shareWithTwoUrls === true) {
				msg = `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareMsg(settings) || '')} ${encodeURIComponent(shortenedUrl)} from @WebMD ${encodeURIComponent(shortenedUrl)}`;
			} else {
				msg = `https://twitter.com/intent/tweet?text=${encodeURIComponent(settings.shareTitle || '')} ${encodeURIComponent(shortenedUrl)} from @WebMD;`;
			}
			this.closeTooltip();
			return msg;
		},

		getWhatsappShareLink(settings) {
			const baseURL = 'https://wa.me/';
			const text = encodeURIComponent(settings.shareTitle || '');
			const shortenedUrl = this.getShortenedUrl(settings.shareLink);
			this.closeTooltip();
			return `${baseURL}?text=${text} ${encodeURIComponent(shortenedUrl)} from @WebMD`
	
		},

		shareMsg(settings) {
			let title = '';
			const urlLength = settings.shareLink.length * 2 + 15;
			let titleLength = 0;

			if (settings.shareTitle) {
				titleLength = settings.shareTitle.length;
			}

			const twitterLength = 280 - urlLength;
			let totalTitleLenth = titleLength - twitterLength;

			if (totalTitleLenth > 0) {
				totalTitleLenth += 3;
				const newTitleLength = titleLength - totalTitleLenth;
				const trimmedTitle = settings.shareTitle.substring(0, newTitleLength);

				title = `${trimmedTitle}...`;
			} else {
				title = `${settings.shareTitle}`;
			}
			this.closeTooltip();
			return title;
		},
		async generateShortenedURL(shareLink) {
			const environment = 1;
			const lifecycle = 0;
			const shortenApiUrl = 'https://api-ssl.bitly.com/v4/shorten';
			const token = '34543b055a4fc76fa6e5969de2abc6f323145392';

			/*
			 * TODO: add a way to get env and lifecycle
			 * let environment = webmd.url.getEnv() || '';
			 * let lifecycle = webmd.url.getLifecycle() || '';
			 */

			/* If shortenedUrl is blank, then make the fetch call; otherwise, retrieve from the global shortenedUrl variable. */
			if ((typeof this.shortenedUrls[shareLink] === 'undefined' || this.shortenedUrls[shareLink] === '')
				&& environment && !lifecycle) {
				/* In case the fetch call does not return by the time window.open() fires, assign the page's full URL */
				this.shortenedUrls[shareLink] = shareLink;

				const response = await fetch(shortenApiUrl,{
					method: 'POST',
					domain: 'wb.md',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify({ long_url: `${shareLink}` }),
				});

				const data = await response.json();
				const smallUrl = data;

				if (typeof smallUrl.link === 'string' && /^https?:\/\/[^.]+\.[^/]+\/.+/gi.test(smallUrl.link)) {
					this.shortenedUrls[shareLink] = smallUrl.link;
				} else {
					this.shortenedUrls[shareLink] = shareLink;
				}
			} else {
				// use the page's full URL for non-production environment and lifecycle
				this.shortenedUrls[shareLink] = shareLink;
			}
		},
		getShortenedUrl(shareLink) {
			this.generateShortenedURL(shareLink);
			return this.shortenedUrls[shareLink] || shareLink;
		},
		openEmail () {
			const self = this;
			const title = self.shareTitle || window.document.title || '';
			const shareLink = self.shareLink || window.location.href;
			window.location.href = `mailto:?subject=${title}&body=I visited WebMD and thought that you would be interested in the information below. %0A${shareLink}%0A %20 %0A To view, click on the address above or copy and paste it into your Web browser.%0A %20 %0A LEARN MORE AT WEBMD - the nation%27s most trusted health and wellness resource.%0A https://www.webmd.com/ %0A Copyright 2019 WebMD, All rights reserved. %0A WebMD does not provide medical advice, diagnosis or treatment.`;
		},
		copyLink () {
			let artNum = 0;
			let url = window.location.href;
			const artId = this.getArticleId();
			if(window && window.infiniteList) {
				artNum = Object.keys(window.infiniteList).indexOf(artId);
				url = window.infiniteList[artId].omniture.s_pagename;
			}
			window.navigator.clipboard.writeText(url);
			this.showTooltipText = true;
			window.setTimeout(() => {
				this.showTooltipText = false;
				window.setTimeout(() => {
					this.showTooltip = false;
				}, 500);
			}, 500);
		},
		toggleTooltip () {
			this.$vwmdPageLink({ moduleName: 'fm-shr_share'});
			this.showTooltip = !this.showTooltip;

			if(!this.isClickListenerAdded && this.showTooltip)
			{
				document.addEventListener("click", this.handleDocumentClick);
				this.isClickListenerAdded = true;
			}
			else if (this.isClickListenerAdded && !this.showTooltip)
			{
				document.removeEventListener("click", this.handleDocumentClick);
				this.isClickListenerAdded = false;
			}

		},
		getArticleId() {
			let artId;
			let currentElement = this.$parent.$el;
			while (currentElement!== null) {
				if (currentElement.attributes && currentElement.attributes['data-artid']?.value) {
				artId = currentElement.attributes['data-artid'].value;
				break; // stop traversing up the DOM tree
				}
				currentElement = currentElement.parentElement;
			}
			if (artId === undefined) {
				artId = 0;
			}
			return artId;
		},
		closeTooltip() {
			this.showTooltip = false;
			document.removeEventListener("click", this.handleDocumentClick);

			if(this.isClickListenerAdded) {
				document.removeEventListener("click", this.handleDocumentClick);
				this.isClickListenerAdded = false;
			}
		},
		handleDocumentClick(args) {
			let targetElement = document.getElementsByClassName('share-text');
			let tooltipEle = document.getElementsByClassName('share-icons-tooltip');
			targetElement = targetElement && targetElement[0];
			tooltipEle = tooltipEle && tooltipEle[0];
			if(args.target.className === 'icon-sb-footer-email' || (targetElement && tooltipEle && args.target.className != targetElement.className && args?.target?.offsetParent?.className != tooltipEle.className)) {
				if (!(args.target.classList.value.includes('icon-sb-footer-svg'))){
					this.closeTooltip();
				}
			}
		},
		translation(text) {
			return this.lang ? this.getTranslationData(this.lang, text) : text;
		},
		getTranslationData(lang, val) {

			const i18n = {
				"es_ES": { // spanish lang
					"Share": "Compartir",
					"ShareonFacebook": "Compartir en Facebook",
					"ShareonTwitter": "Compartir en Twitter",
					"ShareonWhatsapp": "Compartir en WhatsApp",
					"ShareviaEmail": "Compartir por correo electrónico",
					"Copy": "Copiar",
					"copied": "Copiado",
				}
			};

			if (lang) {
				const copyLangStr = clone(val);
				if (lang && i18n[lang]) {
					// remove white spache from str value
					return i18n[lang][copyLangStr.replace(/\s/g, '')] || val;
				} else return val;
			}

			return val;
		},
	},

	mounted() {
		const self = this;
		const title = self.shareTitle || window.document.title || '';
		const shareLink = self.shareLink || window.location.href;
		this.deviceInfo = ua.type;
		Object.keys(this.settings).forEach((i) => {
			if (typeof self.settings[i].settings === 'undefined') {
				self.settings[i].settings = {};
			}

			if (typeof self.settings[i].settings.shareLink === 'undefined') {
				self.settings[i].settings.shareLink = shareLink;
			}

			if (typeof self.settings[i].shareTitle === 'undefined') {
				self.settings[i].settings.shareTitle = title;
			}
		});
	},
};
</script>

<style lang="scss">
$black: #000;
$tablet: 47.938em;
$small-desktop: 64rem;
$white: #FFF;
$wave: #D2D9FF;
$shadow: #ddd;
$carbon: #1B1B1B;
$ultramarine: #3557FF;
$imperial: #00157C;
$font-family-sans: 'Source Sans Pro', Arial, sans-serif;

.module-social-share-footer {
	height: 2.5rem;
	margin-bottom: 0.75rem;
	position: relative;

	.share-icons {
		height: 3.7rem;
		.share-icons-tooltip {
			background-color: $white;
			border-radius: 3px;
			box-shadow: 0 1px 2px 2px $shadow;
			display: flex;
			gap: 1rem;
			margin-left: -6.25rem;
			min-width: 13rem;
			padding: 0.75rem;
			position: absolute;
			text-align: center;

			@media screen and (max-width: $small-desktop) {
				margin-left: auto;
				right: 0;
			}
		}
		.share-icons-tooltip:after {
			background: $white;
			box-shadow: -5px -5px 3px -5px #999;
			content: "";
			height: 0.5rem;
			right: 27%;
			position: absolute;
			top: -4px;
			transform: rotate(45deg);
			width: 0.5rem;

			@media screen and (max-width: $small-desktop) {
				left: auto;
				right: 1.75rem;
			}
		}
	}
	.copy-link-tooltip {
		background: $carbon;
		border-radius: 15px;
		color: $white;
		font-size: 0.875rem;
		left: 75%;
		letter-spacing: normal;
		opacity: 0.7;
		padding: 5px 12px;
		position: absolute;
		top: 4.5rem;
		width: auto;

		@media screen and (max-width: $tablet) {
			left: 10.5rem;
			top: 5rem;
		}
	}

	.share-footer-container {
		align-items: center;
		cursor: pointer;
		display: flex;
		justify-content: right;
		gap: px2rem(5);

		.share-text {
			color: $carbon;
			font-family: $font-family-sans;
			font-size: 0.875rem;
			font-weight: 400;
			letter-spacing: 0.6px;
			line-height: 1.4;
		}

		.icon-sb-footer-share {
			align-items: center;
			background: $white;
			border-radius: 50%;
			color: $ultramarine;
			display: flex;
			height: 2.5rem;
			justify-content: center;
			width: 2.5rem;

			svg {
				fill: currentColor;
			}
		}

		&:hover {
			.icon-sb-footer-share {
				@media screen and (min-width: $small-desktop) {
					background-color: $wave;
				}
			}
		}
	}

	.plugin-socialshare-link {
		align-items: center;
		border-radius: 1.25rem;
		color: $black;
		cursor: pointer;
		display: flex;
		height: 1.5rem;
		justify-content: center;
		width: 1.5rem;

		.icon-sb-footer-facebook, 
		.icon-sb-footer-copy,
		.icon-sb-footer-email,
		.icon-sb-footer-whatsapp {
			align-items: center;
			display: flex;
			height: 1.5rem;
			justify-content: center;
			width: 1.5rem;

			&:hover svg path {
				fill: $imperial;
			}
		}

		.icon-sb-footer-copy {
			margin-top: 0.2rem;
		}

		.icon-sb-footer-twitter {
			align-items: center;
			display: flex;
			height: 1.5rem;
			justify-content: center;
			width: 1.5rem;

			&:hover svg .tw-icon-bg {
				fill: $imperial;
			}

		}
	}

	.plugin-socialshare-copy {
		margin-right: 0;
	}

}

.visually-hidden {
	height: 1px;
	left: -10000px;
	margin: -1px;
	overflow: hidden;
	position: absolute !important;
	top: auto;
	width: 1px;
}
</style>
